require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 190
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/.2.5.1@core-js/library/modules/es7.symbol.async-iterator.js